import { render } from "./SaleChart.vue?vue&type=template&id=192481a6"
import script from "./SaleChart.vue?vue&type=script&lang=js"
export * from "./SaleChart.vue?vue&type=script&lang=js"

import "./SaleChart.vue?vue&type=style&index=0&id=192481a6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__